import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetAreaInputContextDocument,
  type GetAreaInputContextQuery,
  type GetAreaInputContextQueryVariables,
} from "~/features/recordGeoItems/gqls";
import { useTenant } from "~/features/tenant/context";

/** References available for the evidence picker in the area-input editor forms. */
export function useAreaInputContext() {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetAreaInputContextQuery, GetAreaInputContextQueryVariables>(GetAreaInputContextDocument, {
    variables: { tenantId },
  });
}
